/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table as AntTable, Empty, Spin } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { LoadingOutlined } from '@ant-design/icons';
import { GetRowKey } from 'antd/es/table/interface';

interface NiceTableProps {
  data: any[];
  loading: boolean;
  errorFetchingData: boolean;
  columns: ColumnsType<any>;
  retryRequest?: boolean;
  setRetryRequest?: (retryRequest: boolean) => void;
  rowKey: string | number | symbol | GetRowKey<any>;
}

const Table = ({
  data,
  loading,
  columns,
  errorFetchingData,
  rowKey,
}: NiceTableProps) => {
  const CustomLocaleComponent = () => {
    if (loading)
      return (
        <div className="py-10">
          {' '}
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      );
    if (!loading && errorFetchingData) return <div>data fetching error</div>;
    return <Empty />;
  };

  const locale = {
    emptyText: <CustomLocaleComponent />,
    loading: 'loading',
  };

  return (
    <div className="w-full">
      <AntTable
        columns={columns}
        dataSource={data}
        locale={locale}
        pagination={{
          position: ['bottomRight'],
          defaultPageSize: 10,
          total: data.length,
        }}
        className="rounded-0"
        rowKey={rowKey}
      />
    </div>
  );
};

export default Table;
